import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { SideNav, HeaderItem, Logo } from '@terrainvest/react-components';
import { StyledColNoPadd } from '../../View/Common/Grid';

export const StyledCol = styled(StyledColNoPadd)`
    padding: 20px 30px;
    box-sizing: border-box;

    ${media.max.xs`
        padding: 20px 10px;
    `}
`;

export const StyledSideBarAndHeader = styled.div`
    ${media.min.tablet`
        ${SideNav.Styles.StyledSideNav} {
            top: 0;
        }
    `}

    ${HeaderItem.Styles.StyledHeaderItem} {
        ${Logo.Styles.StyledLogo} {
            cursor: pointer;
        }
    }
`;
